module.exports = __webpack_public_path__ + "static/media/btn-prev.bab3ad18.svg";